<p-dialog
  [header]="'Complete Missing Information'"
  [dismissableMask]="false"
  [(visible)]="isModalVisible"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="handleModalHide()"
  [closable]="false"
>
  <div class="warning-message">
    <i class="pi pi-exclamation-triangle"></i>
    <p>
      The selected {{ thirdPartyType === 'repair_facility' ? 'Repair Facility' : 'Service Advisor' }} 
      is missing required information. Please complete the following fields:
    </p>
    <ul>
      <li *ngFor="let field of missingFields">{{ field }}</li>
    </ul>
  </div>

  <form [formGroup]="validationForm" class="form">
    <app-input-field
      [form]="validationForm"
      controlName="name"
      label="Company Name"
      placeholder="Company Name"
    ></app-input-field>

    <div class="form-row">
      <app-input-field
        [form]="validationForm"
        controlName="first_name"
        label="First Name"
        placeholder="Enter First Name"
      ></app-input-field>
      <app-input-field
        [form]="validationForm"
        controlName="last_name"
        label="Last Name"
        placeholder="Enter Last Name"
      ></app-input-field>
    </div>

    <div class="form-row">
      <app-input-field
        [form]="validationForm"
        controlName="mobile"
        mask="(000) 000-0000"
        label="Phone Number"
        placeholder="Enter Phone Number"
      ></app-input-field>
      <app-input-field
        [form]="validationForm"
        controlName="email"
        label="Email"
        placeholder="Enter Email Address"
      ></app-input-field>
    </div>

    <app-address-component [addressForm]="formAddress"></app-address-component>
    
    <app-ngx-loader [loading]="isLoading"></app-ngx-loader>
  </form>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button class="cancel-btn" (click)="toggleModal()">Cancel</button>
      <button (click)="handleFormSubmit()" class="custom-btn">Submit</button>
    </div>
  </ng-template>
</p-dialog>
